module.exports = "/_next/static/images/HempsteadLogo-42dd639a97527e4b716cade5d96eb7ae.png";